const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质 1080P',
    desc: '全站动漫资源支持高清1080P画质在线观看，清晰流畅的视觉享受，让每一帧画面都细腻动人。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载不卡顿',
    desc: '采用智能CDN加速技术，动漫在线观看无需缓冲等待，秒开秒播，追番体验丝滑流畅不中断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配随心看',
    desc: '全面支持电脑、平板和手机浏览器访问，无论在家还是在路上，随时随地打开浏览器即可在线看动漫。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新同步追',
    desc: '紧跟日本播出进度，当日更新的动漫全集第一时间上线。热门动漫网站同步追更，不再错过任何精彩。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净无广告体验',
    desc: '全程无弹窗广告、无恶意跳转，打造纯净的番剧在线观看环境。专注内容本身，享受沉浸式追番乐趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么选择91樱花动漫？五大核心优势为您打造最佳追番体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 text-center group hover:border-primary-200/60 hover:bg-background-50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}